/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Clear_All_ButtonInputs */



/**
* | output |
* | --- |
* | "Clear All" |
*
* @param {Segment_Event_Group_Clear_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_clear_all_button = /** @type {((inputs?: Segment_Event_Group_Clear_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Clear_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tout effacer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Alles löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить все")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部清除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべてクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी साफ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar tudo")
	return /** @type {LocalizedString} */ ("Clear All")
});